<template>
    <div class="content mt-3 mt-md-4">
        <div class="container game-ended__container text-center">
            <div class="row">
                <div class="col">
                    <h2>Your score: <strong>{{ points }}</strong></h2>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <h1 v-if="gameResult === 'win'">Great job, you got more points than <strong>{{ friendName }}</strong>!</h1>
                    <h1 v-else-if="gameResult === 'loss'">Nice try, you got to play with <strong>{{ friendName }}</strong>!</h1>
                    <h1 v-else>Good job! You got as many points as <strong>{{ friendName }}</strong>!</h1>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <img :src="`/images/${celebrityInvite}pic.png`" :title="friendName" :alt="friendName" />
                </div>
            </div>
        </div>
        <transition name="fade">
            <div v-if="showPlayAgain" class="container game-ended__container text-center">
                <div class="mt-1 mt-md-3 row">
                    <div class="col">
                        <h3>Share your result on Facebook or Instagram!</h3>
                        <ShareWidget :gameResult="gameResult"
                                     :showShareWidget="showShareWidget"
                                     :totalScore="points"
                                     :celebrityInvite="celebrityInvite"
                                     :friendName="friendName"
                                     :invitePoints="invitePoints"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col mt-5 play-again-group">
                        <button @click="playAgainAgainstCelebrity" class="btn btn-secondary">Play again</button>
                        <br />
                        <a href="https://race.99math.com/" class="btn btn-secondary mt-1">Choose another opponent</a>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    const pointsToPercentageMapping = {
        30: '99%', 29: '99%', 28: '98%', 27: '97%', 26: '96%', 25: '93%', 24: '91%', 23: '88%', 22: '85%',
        21: '81%', 20: '76%', 19: '71%', 18: '68%', 17: '66%', 16: '61%', 15: '55%', 14: '49%', 13: '46%',
        12: '43%', 11: '40%', 10: '36%', 9: '33%', 8: '29%', 7: '26%', 6: '12%', 5: '9%', 4: '7%',
        3: '4%', 2: '2%', 1: '2%',
    };
    import ShareWidget from "../components/ShareWidget";

    export default {
        components: {
            ShareWidget,
        },
        props: {
            totalAnswers: {
                type: Number,
                required: true,
            },
            points: {
                type: Number,
                required: true,
            },
            correctAnswers: {
                type: Number,
                required: true,
            },
            wrongAnswers: {
                type: Number,
                required: true,
            },
            bot: {
                type: Boolean,
                required: true,
            },
            invitePoints: {
                type: Number,
                required: false,
            },
            friendName: {
                type: String,
                required: false,
            },
            celebrityInvite: {
                type: String,
                required: false,
            },
            showPlayAgain: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                opponentName: 'Friend',
                showShareWidget: false,
            }
        },
        computed: {
            gameResult() {
                if (this.points > this.invitePoints) {
                    return 'win';
                } else if (this.points < this.invitePoints) {
                    return 'loss';
                }
                return 'tie';
            },
            resultPercentage() {
                let closestKey = null;
                for (let score = this.points; score > 0; score--) { // eslint-disable-line
                    if (pointsToPercentageMapping.hasOwnProperty(score)) {
                        closestKey = score;
                        break;
                    }
                }
                return pointsToPercentageMapping[closestKey];
            }
        },
        methods: {
            playAgain() {
                this.$ga.event({
                    eventCategory: 'game',
                    eventAction: 'click',
                    eventLabel: 'playAgainBtn',
                });
                this.redirectHome();
            },
            showPlayAgainOptions() {
                this.$ga.event({
                    eventCategory: 'game',
                    eventAction: 'click',
                    eventLabel: 'showPlayAgainOptions',
                });
            },
            playAgainAgainstCelebrity() {
                this.$ga.event({
                    eventCategory: 'game',
                    eventAction: 'click',
                    eventLabel: 'playAgainAgainstCelebrity',
                });
                this.$router.push({
                    name: 'home.invited',
                    params: {
                        invite: this.celebrityInvite
                    }
                });
            },
            playAgainAgainstBot() {
                this.$ga.event({
                    eventCategory: 'game',
                    eventAction: 'click',
                    eventLabel: 'playAgainAgainstBot',
                });
                this.$router.push({name: 'home'});
            },
            redirectHome() {
                this.$router.push({name: 'home'});
            }
        },
        mounted() {
            if (typeof this.points === 'undefined') {
                this.redirectHome();
            }
            if (this.friendName) {
                this.opponentName = this.friendName;
            }
        },
        created() {
            const self = this;
            setTimeout(function () {
                self.showPlayAgain = !self.showPlayAgain;
            }, 1500);
        }
    }

</script>

<style lang="scss" scoped>
    h1 {
        font-size: 1.6rem;
    }
    h2 {
        font-size: 1.3rem;
    }

    @media (min-width: 767px) {
        h1 {
            font-size: 2rem;
        }
        h2 {
            font-size: 1.8rem;
        }
    }

    .game-ended__container {
        h2 {
            font-weight: bold;
        }

        .progress {
            margin-bottom: 1rem;
            height: 2rem;
            background-color: #6C6C6C;
            border-radius: 0.5rem;
        }

        .bottom-menu {
            button {
                font-size: 20pt;
                width: 80%;
            }
        }
        img {
            max-height: 200px;
            width: 95%;
            max-width: 200px;
            margin: 10px;
        }
        @media (min-width: 767px) {
            img {
                max-height: 350px;
                max-width: 350px;
            }
        }
        .play-again-group {
            .btn {
                width: 300px;
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
</style>
